import { Navigate, Route, Routes } from 'react-router-dom';

import Details from 'src/features/profile/routes/Details';
import Password from 'src/features/profile/routes/Password';
import Settings from 'src/features/profile/routes/Settings';

const ProfileRoutes = () => {
    return (
        <Routes>
            <Route path="" element={<Details />} />
            <Route path="password" element={<Password />} />
            <Route path="settings" element={<Settings />} />
            <Route path="*" element={<Navigate to=".." />} />
        </Routes>
    );
};

export default ProfileRoutes;
